import React, { createContext, useContext, useRef } from "react";

const Ctx = createContext({
  ref: null,
  value: 0,
  onChange: () => {},
  length: 0,
});

export function Carousel({
  children,
  className = "",
  opts,
  value = 0,
  onChange = () => {},
  length = 0,
}) {
  const ref = useRef(null);
  const ctx = { ref, value, onChange, length };
  return (
    <div className={`relative ${className}`}>
      <Ctx.Provider value={ctx}>{children}</Ctx.Provider>
    </div>
  );
}

export function CarouselContent({ children, className = "" }) {
  const { ref } = useContext(Ctx);
  return (
    <div
      ref={ref}
      className={`flex gap-4 overflow-x-auto overflow-y-hidden scroll-smooth no-scrollbar ${className}`}
      style={{ scrollbarWidth: "none", WebkitOverflowScrolling: "touch" }}
    >
      {children}
    </div>
  );
}

export function CarouselItem({ children, className = "", style }) {
  return (
    <div className={`shrink-0 ${className}`} style={style}>
      {children}
    </div>
  );
}

export function CarouselNext({ className = "", children, ...props }) {
  const { ref, value, onChange, length } = useContext(Ctx);

  const onClick = () => {
    const el = ref?.current;
    if (el) el.scrollBy({ left: el.clientWidth * 0.8, behavior: "smooth" });

    if (length > 0 && typeof onChange === "function") {
      onChange((value + 1) % length);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`absolute top-1/2 -translate-y-1/2 rounded-full w-10 h-10 bg-black/50 text-white hover:bg-black/70 flex items-center justify-center ${className}`}
      aria-label="Próximo"
      {...props}
    >
      {children ?? "›"}
    </button>
  );
}

export function CarouselPrevious({ className = "", children, ...props }) {
  const { ref, value, onChange, length } = useContext(Ctx);

  const onClick = () => {
    const el = ref?.current;
    if (el) el.scrollBy({ left: -el.clientWidth * 0.8, behavior: "smooth" });

    if (length > 0 && typeof onChange === "function") {
      onChange((value - 1 + length) % length);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`absolute top-1/2 -translate-y-1/2 rounded-full w-10 h-10 bg-black/50 text-white hover:bg-black/70 flex items-center justify-center ${className}`}
      aria-label="Anterior"
      {...props}
    >
      {children ?? "‹"}
    </button>
  );
}

export default Carousel;
